// The agent CLIs a chat turn can use (D82) and their models. Claude's list is the workflow
// builder's; Cursor is offered, and its turns are refused until Cursor support is built (D67).
import { CLAUDE_MODELS } from "../workflows/drawers/models";

export type Cli = "claude" | "cursor";

export const CLIS: { value: Cli; label: string }[] = [
  { value: "claude", label: "Claude Code" },
  { value: "cursor", label: "Cursor" },
];

export interface ModelOption {
  value: string;
  label: string;
}

const CURSOR_MODELS: ModelOption[] = [
  { value: "auto", label: "Auto" },
  { value: "claude-sonnet-4.5", label: "Claude Sonnet 4.5" },
  { value: "claude-opus-4.1", label: "Claude Opus 4.1" },
  { value: "gpt-5", label: "GPT-5" },
  { value: "gpt-5-codex", label: "GPT-5 Codex" },
  { value: "gemini-2.5-pro", label: "Gemini 2.5 Pro" },
];

/** The models for `cli`, after a "default" choice (empty value: the platform's default). */
export function modelsFor(cli: Cli, defaultLabel: string): ModelOption[] {
  const list =
    cli === "claude"
      ? CLAUDE_MODELS.map((m) => ({ value: m.value, label: m.latest ? `${m.name} (latest)` : `${m.name} · ${m.value}` }))
      : CURSOR_MODELS;
  return [{ value: "", label: defaultLabel }, ...list];
}

export const isCli = (v: string): v is Cli => v === "claude" || v === "cursor";
